import * as angular from 'angular';

(function () {
    'use strict';
    angular.module('app').factory('sharedDataObject', sharedDataObject);

    function sharedDataObject() {
        return {
            chosenNetworkPoint: {}
        };
    }
})();
